import { useState } from 'react';
import {
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import { arrayMove, sortableKeyboardCoordinates } from '@dnd-kit/sortable';
import { useFormikContext } from 'formik';

export const useChangeOrder = ({
  withOrder = true,
  items,
  namePrefix,
  onItemDragEnd,
}: {
  withOrder?: any;
  items: any;
  namePrefix: any;
  onItemDragEnd: any;
}) => {
  const { setFieldValue } = useFormikContext();

  const [activeDragItem, setActiveDragItem] = useState(null);

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    }),
  );

  const handleItemDragOver = (event: any) => {
    const { active, over } = event;

    if (over && active.id !== over.id) {
      const oldIndex = items.findIndex((item: any) => item.id === active.id);
      const newIndex = items.findIndex((item: any) => item.id === over.id);

      let nextItems = [];

      if (withOrder) {
        nextItems = arrayMove(items, oldIndex, newIndex).map(
          (item: typeof items[number], itemIndex: number) => ({
            ...item,
            order: itemIndex + 1,
          }),
        );
      } else {
        nextItems = arrayMove(items, oldIndex, newIndex);
      }

      setFieldValue(namePrefix, nextItems);
    }
  };

  const handleItemDragStart = (event: any) => {
    const { active } = event;

    const dragItem = items.find((item: any) => item.id === active.id);

    setActiveDragItem(dragItem);
  };

  const handleItemDragEnd = () => {
    setActiveDragItem(null);

    if (onItemDragEnd) {
      onItemDragEnd(items.map((item: any) => item.id));
    }
  };

  return {
    sensors,
    activeDragItem,
    onItemDragStart: handleItemDragStart,
    onItemDragEnd: handleItemDragEnd,
    onItemDragOver: handleItemDragOver,
  };
};
